"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var Routes_1 = require("../../../../constants/Routes");
var uri_1 = require("../../../../helpers/uri");
var react_i18next_1 = require("react-i18next");
var classnames_1 = __importDefault(require("classnames"));
var Item = function (_a) {
    var link = _a.link;
    var t = react_i18next_1.useTranslation('common').t;
    var location = react_router_dom_1.useLocation();
    return (react_1.default.createElement("li", { key: link.url, className: classnames_1.default('account-nav__item', {
            'account-nav__item--active': !!location.pathname.match(link.url),
        }) },
        react_1.default.createElement(react_router_dom_1.Link, { to: {
                pathname: uri_1.createRoute({
                    path: Routes_1.Routes.Account.path + "/" + link.url,
                }),
            } },
            ' ',
            react_1.default.createElement("i", { className: "cm-icon " + link.icon }),
            " ",
            t(link.title)),
        react_1.default.createElement("i", { className: 'icon-chevron-right' })));
};
exports.default = react_1.memo(Item);
